import axios from "axios";
import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";

const ContactUs = () => {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        mobile: "",
        serviceName: "",
        message: "",
    });

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            setLoading(true);

            const response = await axios.post(
                `${process.env.REACT_APP_BASE_URL}services`, // 👈 endpoint
                formData,
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            // console.log("Success:", response.data);


            setFormData({
                name: "",
                email: "",
                mobile: "",
                // location: "",
                serviceName: "",
                message: "",
            });

        } catch (error) {
            console.error("Error:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    }, []);

    return (
        <>
            <div className="boxed_wrapper ltr">
                {/*Start breadcrumb area paroller*/}
                <section className="breadcrumb-area">
                    <div className="breadcrumb-area-bg" style={{ backgroundImage: 'url(assets/images/breadcrumb/breadcrumb-1.jpg)' }}>
                    </div>
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-12">
                                <div className="inner-content">
                                    <div className="title">
                                        <h2>Contact Us</h2>
                                    </div>
                                    <div className="breadcrumb-menu">
                                        <ul>
                                            <li><NavLink to="/">Home</NavLink></li>
                                            <li><i className="fa fa-angle-right" aria-hidden="true" /></li>
                                            <li className="active">Contact Us</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {/*End breadcrumb area*/}



                <div>
                    {/*Start Google map area*/}
                    <section className="google-map-area">
                        <div className="container-fluid">
                            <div className="contact-page-map-outer">
                                {/*Map Canvas*/}
                                {/* <div className="map-canvas" data-zoom={12} data-lat="-37.817085" data-lng="144.955631" data-type="roadmap" data-hue="#ffc400" data-title="Envato" data-icon-path="assets/images/icon/map-marker.png" data-content="Melbourne VIC 3000, Australia<br><a href='mailto:info@youremail.com'>info@youremail.com</a>">
                                </div> */}
                                <div className="embed-map-responsive"><div className="embed-map-container"><iframe className="embed-map-frame" frameBorder={0} scrolling="no" marginHeight={0} marginWidth={0} src="https://maps.google.com/maps?width=1905&height=600&hl=en&q=24-6-674%2C%20OLD%20MILITARY%20COLONY%2C%20DHARGAMITTA%2C%20NELLORE%2C%20524003&t=&z=14&ie=UTF8&iwloc=B&output=embed" /><a href="https://funclicker.org" style={{ fontSize: '2px!important', color: 'gray!important', position: 'absolute', bottom: 0, left: 0, zIndex: 1, maxHeight: '1px', overflow: 'hidden' }}>Fun Clicker</a></div><style dangerouslySetInnerHTML={{ __html: ".embed-map-responsive{position:relative;text-align:right;width:100%;height:0;padding-bottom:23.62204724409449%;}.embed-map-container{overflow:hidden;background:none!important;width:100%;height:100%;position:absolute;top:0;left:0;}.embed-map-frame{width:100%!important;height:100%!important;position:absolute;top:0;left:0;}" }} /></div>


                            </div>
                        </div>
                    </section>
                    {/*Start Google map area*/}
                    {/*Start Contact Info Area*/}
                    <section className="contact-info-area">
                        <div className="container">
                            <div className="row">
                                {/*Start Single Contact Info Box*/}
                                <div className="col-xl-4 col-lg-6 col-md-6">
                                    <div className="single-contact-info-box">
                                        <div className="icon">
                                            <div className="shape-bg" />
                                            <span className="icon-placeholder" />
                                        </div>
                                        <div className="text">
                                            <h4><NavLink to="/">Office Location</NavLink></h4>
                                            <p>24-6-674, OLD MILITARY COLONY, DHARGAMITTA, NELLORE, 524003.</p>
                                        </div>
                                    </div>
                                </div>
                                {/*End Single Contact Info Box*/}
                                {/*Start Single Contact Info Box*/}
                                <div className="col-xl-4 col-lg-6 col-md-6">
                                    <div className="single-contact-info-box">
                                        <div className="icon">
                                            <div className="shape-bg" />
                                            <span className="flaticon-opened" />
                                        </div>
                                        <div className="text">
                                            <h4><NavLink to="mailto:info@budplan.in">Company Email</NavLink></h4>
                                            <p className="text1"><NavLink to="mailto:info@budplan.in">info@budplan.in</NavLink></p>
                                            <p className="text1" style={{ color: '#ffffff' }}><p style={{ color: '#ffffff' }} to="mailto:info@budplan.in">info@budplan.in</p></p>
                                        </div>
                                    </div>
                                </div>
                                {/*End Single Contact Info Box*/}
                                {/*Start Single Contact Info Box*/}
                                <div className="col-xl-4 col-lg-6 col-md-6">
                                    <div className="single-contact-info-box">
                                        <div className="icon">
                                            <div className="shape-bg" />
                                            <span className="flaticon-phone-call-1" />
                                        </div>
                                        <div className="text">
                                            <h4><NavLink to="tel:9876543210">Contact Us</NavLink></h4>
                                            <p className="text1"><NavLink to="tel:9989574919">+91 9989574919</NavLink></p>
                                            <p className="text1" style={{ color: '#ffffff' }}><p style={{ color: '#ffffff' }} to="tel:9989574919">+91 9989574919</p></p>
                                        </div>
                                    </div>
                                </div>
                                {/*End Single Contact Info Box*/}
                            </div>
                        </div>
                    </section>
                    {/*End Contact Info Area*/}
                    {/*Start Main Contact Form Area*/}
                    <section className="main-contact-form-area">
                        <div className="container">
                            <div className="sec-title text-center">
                                <h2>Leave a Comment</h2>
                            </div>
                            <div className="row">
                                <div className="col-xl-12">
                                    <div className="contact-style1_form">
                                        <div className="contact-form">
                                            <form id="contact-form" name="contact_form" className="default-form2" onSubmit={handleSubmit}>
                                                <div className="row">
                                                    <div className="col-xl-6">
                                                        <div className="input-box">
                                                            <input
                                                                type="text"
                                                                name="name"
                                                                placeholder="Full Name"
                                                                value={formData.name}
                                                                onChange={handleChange}
                                                                required
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-xl-6">
                                                        <div className="input-box">
                                                            <input
                                                                type="email"
                                                                name="email"
                                                                placeholder="Email"
                                                                value={formData.email}
                                                                onChange={handleChange}
                                                                required
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-xl-6">
                                                        <div className="input-box">
                                                            <input
                                                                type="text"
                                                                name="mobile"
                                                                placeholder="mobile"
                                                                value={formData.mobile}
                                                                onChange={handleChange}
                                                                required
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-xl-6">
                                                        <div className="input-box">
                                                            <input
                                                                type="text"
                                                                name="serviceName"
                                                                placeholder="Subject"
                                                                value={formData.serviceName}
                                                                onChange={handleChange}
                                                                required
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-xl-12 text-center">
                                                        <div className="input-box two">
                                                            <textarea
                                                                name="message"
                                                                placeholder="Enter your message..."
                                                                value={formData.message}
                                                                onChange={handleChange}
                                                                required
                                                            />
                                                        </div>
                                                        <div className="button-box">
                                                            <input id="form_botcheck" name="form_botcheck" className="form-control" type="hidden" defaultValue />
                                                            <button className="btn-one" type="submit" data-loading-text="Please wait...">
                                                                <span className="txt">Submit Now</span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    {/*End Main Contact Form Area*/}
                </div>



            </div>
        </>
    )
}

export default ContactUs;